import { render } from "./ContribuicaoGithub.vue?vue&type=template&id=7ca13f78&scoped=true"
import script from "./ContribuicaoGithub.vue?vue&type=script&lang=js"
export * from "./ContribuicaoGithub.vue?vue&type=script&lang=js"

import "./ContribuicaoGithub.vue?vue&type=style&index=0&id=7ca13f78&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca13f78"]])

export default __exports__